import React from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

/**
 * Reads ?jwt=... once, shows a notistack toast, strips it from the URL,
 * and returns the token so the parent can pass it to the login() call.
 * No storage. No other side effects.
 */
export default function useGatewayJwt() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [gatewayJwt, setGatewayJwt] = React.useState(null);
  const gatewayBase = process.env.REACT_APP_GATEWAY_BASE;

  React.useEffect(() => {
    const rawJwt = (searchParams.get('jwt') || '').trim() || null;

    if (rawJwt) {
      setGatewayJwt(rawJwt);
      enqueueSnackbar(t('login_page.jwt_present', 'Security token detected.'), { variant: 'success' });
    } else {
      // redirect to verify gate on https://manage.flexicity.sk/muse/gate-verify
    }

    // Strip only the jwt param, keep others (e.g., ?s=slug)
    const params = new URLSearchParams(searchParams);
    if (params.has('jwt')) {
      params.delete('jwt');
      navigate(
        { pathname: location.pathname, search: params.toString() ? `?${params.toString()}` : '' },
        { replace: true }
      );
    }
    // run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return gatewayJwt;
}
